// import { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import { MapPin, CreditCard, Truck, Home, CheckCircle, Loader2, ArrowLeft } from "lucide-react";
// import Navbar from "@/components/Navbar";
// import MobileNav from "@/components/MobileNav";
// import { useCart } from "@/contexts/CartContext";
// import { useAuth } from "@/contexts/AuthContext";
// import { useLanguage } from "@/contexts/LanguageContext";
// import { toast } from "sonner";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// export default function Checkout() {
//   const { items, subtotal, clearCart } = useCart();
//   const { user, authHeaders } = useAuth();
//   const { t } = useLanguage();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { coupon = '', discount = 0, deliveryCharge = 0, total = subtotal } = location.state || {};

//   const [step, setStep] = useState(1);
//   const [placing, setPlacing] = useState(false);
//   const [paymentMethod, setPaymentMethod] = useState('cod');
//   const [deliveryType, setDeliveryType] = useState('delivery');
//   const [address, setAddress] = useState({
//     label: 'Home', line1: '', line2: '', city: '', state: 'Uttar Pradesh', pincode: '', phone: user?.phone || ''
//   });

//   // Load saved addresses
//   const [savedAddresses, setSavedAddresses] = useState(user?.addresses || []);

//   useEffect(() => {
//     if (items.length === 0) navigate('/cart');
//   }, []);

//   const handleAddressChange = (field, value) => setAddress(prev => ({ ...prev, [field]: value }));

//   const validateAddress = () => {
//     if (!address.line1 || !address.city || !address.pincode || !address.phone) {
//       toast.error("Please fill all address fields");
//       return false;
//     }
//     if (address.pincode.length !== 6) { toast.error("Enter valid 6-digit pincode"); return false; }
//     if (address.phone.length < 10) { toast.error("Enter valid phone number"); return false; }
//     return true;
//   };

//   const loadRazorpay = () => new Promise(resolve => {
//     if (window.Razorpay) { resolve(true); return; }
//     const script = document.createElement('script');
//     script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//     script.onload = () => resolve(true);
//     script.onerror = () => resolve(false);
//     document.body.appendChild(script);
//   });

//   const handleRazorpayPayment = async (finalTotal) => {
//     const ok = await loadRazorpay();
//     if (!ok) { toast.error("Payment gateway unavailable. Switching to COD."); return null; }
//     try {
//       const keyRes = await axios.get(`${API}/payment/key`, { headers: authHeaders() });
//       const orderRes = await axios.post(`${API}/payment/create-order`, { amount: finalTotal }, { headers: authHeaders() });
//       if (orderRes.data.mock) {
//         // Mock payment mode
//         toast.info("Using mock payment (Razorpay keys not configured)");
//         return { razorpay_payment_id: `mock_pay_${Date.now()}`, razorpay_order_id: orderRes.data.id, razorpay_signature: 'mock' };
//       }
//       return new Promise((resolve, reject) => {
//         const options = {
//           key: keyRes.data.key_id,
//           amount: orderRes.data.amount,
//           currency: 'INR',
//           name: 'RAS RAJ – The Mithai Shop',
//           description: 'Order Payment',
//           order_id: orderRes.data.id,
//           prefill: { name: user?.name || '', email: user?.email || '', contact: address.phone },
//           theme: { color: '#9B111E' },
//           handler: (response) => resolve(response),
//         };
//         const rzp = new window.Razorpay(options);
//         rzp.on('payment.failed', () => reject(new Error('Payment failed')));
//         rzp.open();
//       });
//     } catch (e) {
//       throw e;
//     }
//   };

//   const placeOrder = async () => {
//     if (!validateAddress()) return;
//     setPlacing(true);
//     try {
//       let paymentData = {};
//       if (paymentMethod === 'razorpay') {
//         const finalTotal = total || subtotal;
//         try {
//           const rzpData = await handleRazorpayPayment(finalTotal);
//           paymentData = { razorpay_payment_id: rzpData.razorpay_payment_id, razorpay_order_id: rzpData.razorpay_order_id };
//         } catch (e) {
//           toast.error("Payment cancelled or failed");
//           setPlacing(false);
//           return;
//         }
//       }

//       const orderData = {
//         items: items.map(i => ({
//           product_id: i.product_id,
//           product_name: i.product_name,
//           weight: i.weight,
//           quantity: i.quantity,
//           price: i.price,
//           image: i.image,
//         })),
//         address,
//         delivery_type: deliveryType,
//         payment_method: paymentMethod,
//         coupon_code: coupon || null,
//         notes: null,
//         ...paymentData,
//       };

//       const r = await axios.post(`${API}/orders`, orderData, { headers: authHeaders() });
//       clearCart();
//       toast.success(t('orderPlaced'));
//       navigate('/orders', { state: { newOrder: r.data } });
//     } catch (e) {
//       toast.error(e.response?.data?.detail || "Failed to place order");
//     } finally { setPlacing(false); }
//   };

//   const finalTotal = total || subtotal;

//   return (
//     <div className="min-h-screen bg-[#FFF6E5] pb-24 md:pb-8">
//       <Navbar />
//       <div className="container mx-auto px-4 max-w-3xl py-6">
//         <div className="flex items-center gap-3 mb-6">
//           <button onClick={() => navigate('/cart')} className="p-2 hover:bg-[#F5E6D3] rounded-full text-[#9B111E]"><ArrowLeft className="h-5 w-5" /></button>
//           <h1 className="text-2xl font-bold text-[#2A2A2A]" style={{ fontFamily: 'Playfair Display, serif' }}>Checkout</h1>
//         </div>

//         {/* Order Summary */}
//         <div className="bg-white rounded-xl p-4 border border-[#E6D5BC] mb-6">
//           <h3 className="font-semibold text-[#2A2A2A] mb-3">Your Order ({items.length} items)</h3>
//           <div className="space-y-2 max-h-40 overflow-y-auto">
//             {items.map(item => (
//               <div key={`${item.product_id}-${item.weight}`} className="flex justify-between text-sm">
//                 <span className="text-gray-600">{item.product_name} × {item.quantity} ({item.weight})</span>
//                 <span className="font-medium">₹{item.price * item.quantity}</span>
//               </div>
//             ))}
//           </div>
//           <div className="border-t border-[#E6D5BC] mt-3 pt-3 space-y-1 text-sm">
//             <div className="flex justify-between"><span className="text-gray-500">{t('subtotal')}</span><span>₹{subtotal}</span></div>
//             {deliveryCharge > 0 && <div className="flex justify-between"><span className="text-gray-500">{t('deliveryCharge')}</span><span>₹{deliveryCharge}</span></div>}
//             {deliveryCharge === 0 && <div className="flex justify-between text-green-600"><span>Delivery</span><span>FREE</span></div>}
//             {discount > 0 && <div className="flex justify-between text-green-600"><span>{t('discount')}</span><span>-₹{discount}</span></div>}
//             <div className="flex justify-between font-bold text-base pt-1 border-t border-[#E6D5BC]">
//               <span>{t('total')}</span><span className="text-[#9B111E]" data-testid="checkout-total">₹{finalTotal}</span>
//             </div>
//           </div>
//         </div>

//         {/* Delivery Type */}
//         <div className="bg-white rounded-xl p-4 border border-[#E6D5BC] mb-4">
//           <h3 className="font-semibold text-[#2A2A2A] mb-3 flex items-center gap-2">
//             <Truck className="h-4 w-4 text-[#9B111E]" /> {t('deliveryType')}
//           </h3>
//           <div className="grid grid-cols-2 gap-3">
//             {[{ id: 'delivery', label: t('homeDelivery'), icon: Home }, { id: 'pickup', label: t('storePickup'), icon: MapPin }].map(opt => (
//               <button
//                 key={opt.id}
//                 onClick={() => setDeliveryType(opt.id)}
//                 className={`flex items-center gap-2 p-3 rounded-xl border-2 text-sm font-medium transition-all ${deliveryType === opt.id ? 'border-[#9B111E] bg-[#9B111E]/5 text-[#9B111E]' : 'border-[#E6D5BC] text-gray-600 hover:border-[#D4AF37]'}`}
//                 data-testid={`delivery-type-${opt.id}`}
//               >
//                 <opt.icon className="h-4 w-4" /> {opt.label}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Delivery Address */}
//         {deliveryType === 'delivery' && (
//           <div className="bg-white rounded-xl p-4 border border-[#E6D5BC] mb-4" data-testid="address-form">
//             <h3 className="font-semibold text-[#2A2A2A] mb-4 flex items-center gap-2">
//               <MapPin className="h-4 w-4 text-[#9B111E]" /> {t('deliveryAddress')}
//             </h3>
//             <div className="space-y-3">
//               <input className="w-full border-2 border-[#E6D5BC] rounded-lg px-3 py-2 text-sm" placeholder={t('addressLine')} value={address.line1} onChange={e => handleAddressChange('line1', e.target.value)} data-testid="address-line1" />
//               <input className="w-full border-2 border-[#E6D5BC] rounded-lg px-3 py-2 text-sm" placeholder="Landmark (optional)" value={address.line2} onChange={e => handleAddressChange('line2', e.target.value)} />
//               <div className="grid grid-cols-2 gap-3">
//                 <input className="border-2 border-[#E6D5BC] rounded-lg px-3 py-2 text-sm" placeholder={t('city')} value={address.city} onChange={e => handleAddressChange('city', e.target.value)} data-testid="address-city" />
//                 <input className="border-2 border-[#E6D5BC] rounded-lg px-3 py-2 text-sm" placeholder={t('pincode')} value={address.pincode} onChange={e => handleAddressChange('pincode', e.target.value.replace(/\D/g,'').slice(0,6))} data-testid="address-pincode" />
//               </div>
//               <input className="w-full border-2 border-[#E6D5BC] rounded-lg px-3 py-2 text-sm" placeholder={t('phone')} value={address.phone} onChange={e => handleAddressChange('phone', e.target.value.replace(/\D/g,'').slice(0,10))} data-testid="address-phone" />
//             </div>
//           </div>
//         )}

//         {/* Payment Method */}
//         <div className="bg-white rounded-xl p-4 border border-[#E6D5BC] mb-6">
//           <h3 className="font-semibold text-[#2A2A2A] mb-3 flex items-center gap-2">
//             <CreditCard className="h-4 w-4 text-[#9B111E]" /> {t('paymentMethod')}
//           </h3>
//           <div className="space-y-2">
//             {[
//               { id: 'cod', label: t('cod'), desc: 'Pay when your order arrives' },
//               { id: 'razorpay', label: 'Pay Online (UPI / Card)', desc: 'Secure payment via Razorpay' },
//             ].map(opt => (
//               <button
//                 key={opt.id}
//                 onClick={() => setPaymentMethod(opt.id)}
//                 className={`w-full flex items-center gap-3 p-3 rounded-xl border-2 text-left transition-all ${paymentMethod === opt.id ? 'border-[#9B111E] bg-[#9B111E]/5' : 'border-[#E6D5BC] hover:border-[#D4AF37]'}`}
//                 data-testid={`payment-${opt.id}`}
//               >
//                 <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 ${paymentMethod === opt.id ? 'border-[#9B111E]' : 'border-gray-300'}`}>
//                   {paymentMethod === opt.id && <div className="w-2 h-2 rounded-full bg-[#9B111E]" />}
//                 </div>
//                 <div>
//                   <div className="text-sm font-semibold text-[#2A2A2A]">{opt.label}</div>
//                   <div className="text-xs text-gray-500">{opt.desc}</div>
//                 </div>
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Place Order Button */}
//         <button
//           onClick={placeOrder}
//           disabled={placing}
//           className="w-full btn-brand-primary py-4 text-base font-semibold flex items-center justify-center gap-2"
//           data-testid="place-order-btn"
//         >
//           {placing ? (
//             <><Loader2 className="h-5 w-5 animate-spin" /> Processing...</>
//           ) : (
//             <><CheckCircle className="h-5 w-5" /> {t('placeOrder')} — ₹{finalTotal}</>
//           )}
//         </button>
//       </div>
//       <MobileNav />
//     </div>
//   );
// }
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Truck, Home, CreditCard, Banknote, Smartphone, CheckCircle, Loader2, ArrowLeft, ShieldCheck } from "lucide-react";
import Navbar from "@/components/Navbar";
import MobileNav from "@/components/MobileNav";
import { useCart } from "@/contexts/CartContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { toast } from "sonner";

export default function Checkout() {
  const { items, subtotal, clearCart } = useCart();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const [deliveryType, setDeliveryType] = useState('delivery');
  const [paymentMethod, setPaymentMethod] = useState('upi');
  const [isProcessing, setIsProcessing] = useState(false);
  const [showFakeRazorpay, setShowFakeRazorpay] = useState(false);
  
  const [address, setAddress] = useState({
    name: 'Rahul Tiwari', phone: '9876543210', line1: '14, Station Road, Near Bank of Baroda', city: 'Amethi', pincode: '227405'
  });

  const deliveryCharge = deliveryType === 'delivery' ? 40 : 0;
  const total = subtotal + deliveryCharge;

  useEffect(() => {
    if (items.length === 0) navigate('/cart');
    window.scrollTo(0, 0);
  }, [items, navigate]);

  const handleAddressChange = (field, value) => setAddress(prev => ({ ...prev, [field]: value }));

  // THE PITCH SIMULATION MAGIC
  const handlePlaceOrder = () => {
    if (!address.name || !address.phone) {
      toast.error("Please fill contact details");
      return;
    }

    if (paymentMethod === 'cod') {
      processSuccess();
    } else {
      // Show the fake Razorpay popup for online payments
      setShowFakeRazorpay(true);
      setTimeout(() => {
        setShowFakeRazorpay(false);
        processSuccess();
      }, 3500); // Fake 3.5 second processing time
    }
  };

  const processSuccess = () => {
    setIsProcessing(true);
    setTimeout(() => {
      clearCart();
      toast.success("Order Placed Successfully!", {
        description: "Your order #ORD-84729 has been confirmed."
      });
      navigate('/products'); // In the next step, we will route this to a real Order History page
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-[#FFF6E5] pb-24 md:pb-8">
      <Navbar />
      
      {/* FAKE RAZORPAY POPUP (For Pitching) */}
      {showFakeRazorpay && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden animate-in zoom-in duration-200">
            <div className="bg-[#02042B] p-4 text-white flex justify-between items-center">
              <span className="font-bold tracking-wider">Razorpay</span>
              <span className="text-sm border border-white/30 px-2 py-0.5 rounded">Test Mode</span>
            </div>
            <div className="p-6 text-center">
              <div className="w-16 h-16 border-4 border-[#02042B] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <h3 className="text-lg font-bold text-gray-800 mb-1">Processing Payment...</h3>
              <p className="text-sm text-gray-500">Please do not close this window or press back.</p>
              <div className="mt-6 bg-gray-50 p-3 rounded-lg border border-gray-100">
                <p className="text-sm text-gray-600">Paying <strong className="text-black">RAS RAJ THE MITHAI SHOP</strong></p>
                <p className="text-xl font-bold text-black mt-1">₹{total}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 max-w-5xl py-6">
        <div className="flex items-center gap-3 mb-6">
          <button onClick={() => navigate('/cart')} className="p-2 hover:bg-[#F5E6D3] rounded-full text-[#9B111E] transition-colors"><ArrowLeft className="h-5 w-5" /></button>
          <h1 className="text-2xl md:text-3xl font-bold text-[#2A2A2A]" style={{ fontFamily: 'Playfair Display, serif' }}>Secure Checkout</h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* LEFT COLUMN: Details & Payment */}
          <div className="lg:col-span-2 space-y-6">
            
            {/* 1. Delivery Options */}
            <div className="bg-white rounded-2xl p-5 md:p-6 border border-[#E6D5BC] shadow-sm">
              <h3 className="font-bold text-[#2A2A2A] text-lg mb-4 flex items-center gap-2">
                <span className="bg-[#9B111E] text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">1</span>
                Delivery Method
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <button
                  onClick={() => setDeliveryType('delivery')}
                  className={`flex flex-col items-center justify-center gap-2 p-4 rounded-xl border-2 transition-all ${deliveryType === 'delivery' ? 'border-[#D4AF37] bg-[#FFF6E5]' : 'border-gray-100 hover:border-[#E6D5BC]'}`}
                >
                  <Home className={`h-6 w-6 ${deliveryType === 'delivery' ? 'text-[#D4AF37]' : 'text-gray-400'}`} />
                  <span className={`font-semibold text-sm ${deliveryType === 'delivery' ? 'text-[#2A2A2A]' : 'text-gray-500'}`}>Home Delivery</span>
                </button>
                <button
                  onClick={() => setDeliveryType('pickup')}
                  className={`flex flex-col items-center justify-center gap-2 p-4 rounded-xl border-2 transition-all ${deliveryType === 'pickup' ? 'border-[#D4AF37] bg-[#FFF6E5]' : 'border-gray-100 hover:border-[#E6D5BC]'}`}
                >
                  <MapPin className={`h-6 w-6 ${deliveryType === 'pickup' ? 'text-[#D4AF37]' : 'text-gray-400'}`} />
                  <span className={`font-semibold text-sm ${deliveryType === 'pickup' ? 'text-[#2A2A2A]' : 'text-gray-500'}`}>Store Pickup</span>
                </button>
              </div>
            </div>

            {/* 2. Address Form */}
            <div className="bg-white rounded-2xl p-5 md:p-6 border border-[#E6D5BC] shadow-sm">
              <h3 className="font-bold text-[#2A2A2A] text-lg mb-4 flex items-center gap-2">
                <span className="bg-[#9B111E] text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">2</span>
                Contact Details
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1">
                  <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Full Name</label>
                  <input className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all" value={address.name} onChange={e => handleAddressChange('name', e.target.value)} />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Phone Number</label>
                  <input className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all" value={address.phone} onChange={e => handleAddressChange('phone', e.target.value)} />
                </div>
                {deliveryType === 'delivery' && (
                  <>
                    <div className="space-y-1 md:col-span-2 mt-2">
                      <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Complete Address</label>
                      <input className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all" value={address.line1} onChange={e => handleAddressChange('line1', e.target.value)} />
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">City</label>
                      <input className="w-full border border-gray-200 bg-gray-50 text-gray-600 rounded-lg px-4 py-2.5 text-sm outline-none" value={address.city} readOnly />
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Pincode</label>
                      <input className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all" value={address.pincode} onChange={e => handleAddressChange('pincode', e.target.value)} />
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* 3. Payment Methods */}
            <div className="bg-white rounded-2xl p-5 md:p-6 border border-[#E6D5BC] shadow-sm">
              <div className="flex justify-between items-center mb-4">
                <h3 className="font-bold text-[#2A2A2A] text-lg flex items-center gap-2">
                  <span className="bg-[#9B111E] text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">3</span>
                  Payment
                </h3>
                <span className="flex items-center gap-1 text-xs font-semibold text-green-600 bg-green-50 px-2 py-1 rounded"><ShieldCheck size={14}/> 100% Secure</span>
              </div>
              
              <div className="space-y-3">
                {[
                  { id: 'upi', icon: Smartphone, title: 'UPI / QR Code', desc: 'Google Pay, PhonePe, Paytm' },
                  { id: 'card', icon: CreditCard, title: 'Credit / Debit Card', desc: 'Visa, Mastercard, RuPay' },
                  { id: 'cod', icon: Banknote, title: 'Cash on Delivery', desc: 'Pay when you receive the order' },
                ].map(method => (
                  <button
                    key={method.id}
                    onClick={() => setPaymentMethod(method.id)}
                    className={`w-full flex items-center gap-4 p-4 rounded-xl border-2 text-left transition-all ${paymentMethod === method.id ? 'border-[#9B111E] bg-[#9B111E]/5' : 'border-gray-100 hover:border-[#E6D5BC]'}`}
                  >
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${paymentMethod === method.id ? 'border-[#9B111E]' : 'border-gray-300'}`}>
                      {paymentMethod === method.id && <div className="w-2.5 h-2.5 rounded-full bg-[#9B111E]" />}
                    </div>
                    <div className="bg-white p-2 rounded-lg border border-gray-100 shadow-sm text-[#9B111E]">
                      <method.icon size={20} />
                    </div>
                    <div>
                      <div className="font-bold text-[#2A2A2A]">{method.title}</div>
                      <div className="text-xs text-gray-500">{method.desc}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>

          </div>

          {/* RIGHT COLUMN: Order Summary */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl p-5 md:p-6 border border-[#E6D5BC] shadow-sm sticky top-24">
              <h3 className="font-bold text-[#2A2A2A] text-lg mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>Order Summary</h3>
              
              <div className="space-y-4 max-h-60 overflow-y-auto pr-2 custom-scrollbar mb-4">
                {items.map(item => (
                  <div key={`${item.product_id}-${item.weight}`} className="flex gap-3">
                    <div className="w-16 h-16 rounded-lg overflow-hidden border border-[#E6D5BC] shrink-0 bg-[#F5E6D3]">
                      <img src={item.image} alt={item.product_name} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1">
                      <div className="font-bold text-[#2A2A2A] text-sm leading-tight mb-1">{item.product_name}</div>
                      <div className="text-xs text-gray-500">{item.weight} × {item.quantity}</div>
                      <div className="font-bold text-[#9B111E] text-sm mt-1">₹{item.price * item.quantity}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="border-t border-dashed border-gray-300 pt-4 space-y-2 mb-4">
                <div className="flex justify-between text-sm text-gray-600">
                  <span>Subtotal</span>
                  <span className="font-semibold text-[#2A2A2A]">₹{subtotal}</span>
                </div>
                <div className="flex justify-between text-sm text-gray-600">
                  <span>Delivery Charge</span>
                  <span className={deliveryCharge === 0 ? "font-bold text-green-600" : "font-semibold text-[#2A2A2A]"}>
                    {deliveryCharge === 0 ? 'FREE' : `₹${deliveryCharge}`}
                  </span>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-4 mb-6">
                <div className="flex justify-between items-end">
                  <span className="font-bold text-lg text-[#2A2A2A]">Total</span>
                  <div className="text-right">
                    <span className="text-[10px] text-gray-500 block mb-0.5">Inclusive of all taxes</span>
                    <span className="font-bold text-2xl text-[#9B111E]">₹{total}</span>
                  </div>
                </div>
              </div>

              <button
                onClick={handlePlaceOrder}
                disabled={isProcessing}
                className="w-full bg-[#9B111E] hover:bg-[#7A0C16] text-white rounded-xl py-4 text-base font-bold flex items-center justify-center gap-2 transition-all shadow-lg shadow-[#9B111E]/20 active:scale-95"
              >
                {isProcessing ? (
                  <><Loader2 className="h-5 w-5 animate-spin" /> Confirming Order...</>
                ) : (
                  <><CheckCircle className="h-5 w-5" /> Pay ₹{total}</>
                )}
              </button>
            </div>
          </div>

        </div>
      </div>
      <MobileNav />
    </div>
  );
}